import { Box, Dialog, IconButton, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Close from "../assets/svg/Close";
import { colors } from "../utils/colors/Index";
import CustomButton from "./common/CustomButton";
import TextFieldBox from "./common/TextField";

import { apiGet, apiPatch, apiPost } from "../utils/Api/ApiCalls";
import { API_ROUTES } from "../utils/Api/ApiConfig";
import PlanTable from "./PlansTable";
import Loader from "./common/Loader";
function PlanDetailsPopup({ open, setOpen }) {
  const [formData, setFormData] = useState({
    planname: "",
    duration: null,
    price: null,
    discount:null
  });
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [planData, setPlanData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [edit, setEdit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.planname) newErrors.planname = "Plan Name is required";

    if (!formData.duration) newErrors.duration = "Duration is required";
    if (!formData.price) newErrors.price = "price is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleClose = () => {
    setOpen(false);
    setFormData({
      planname: "",
      duration: null,
      price: null,
    });
  };
  const fetctPlanDetails = async () => {
    setIsLoading(true);
    try {
      const response = await apiGet(API_ROUTES.GET_PLANS);
      if (response.status === 200) {
        setPlanData(response?.data?.plans);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetctPlanDetails();
  }, []);
  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoader(true);
    if (edit) {
      try {
        const body = {
          planId: formData?._id,
          name: formData?.planname,
          price: formData?.price,
          duration: formData?.duration,
          action: "update",
        };
        const response = await apiPatch(API_ROUTES.UPDATE_PLANS, body);
        if (response.status === 200) {
          console.log("Form submitted successfully:", response.data);
          setFormData({
            planname: "",
            duration: "",
            price: "",
          });
          fetctPlanDetails();
          setEdit(false);
        }
      } catch (error) {
        console.log("Error submitting form:", error);
      } finally {
        setLoader(false);
        setEdit(false);
      }
    } else {
      try {
        const body = {
          name: formData?.planname,
          price: formData?.price,
          duration: formData?.duration,
        };
        const response = await apiPost(API_ROUTES.POST_PLANS, body);
        if (response.status === 200) {
          console.log("Form submitted successfully:", response.data);
          setFormData({
            planname: "",
            duration: "",
            price: "",
          });
          fetctPlanDetails();
        }
      } catch (error) {
        console.log("Error submitting form:", error);
      } finally {
        setLoader(false);
      }
    }
  };
  const handleDelete = async (_id) => {
    setIsLoading(true);
    const body = {
      planId: _id,
      action: "delete",
    };
    try {
      const response = await apiPatch(API_ROUTES.UPDATE_PLANS, body);
      if (response.status === 200) {
        console.log(response.data);
        fetctPlanDetails();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      PaperProps={{ elevation: 3, sx: { borderRadius: "1rem" } }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          padding: "1rem",
          rowGap: "0.5rem",
          position: "relative",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "0",
            right: "0",
            padding: "0.5rem",
          }}
        >
          <Close />
        </IconButton>
        <Typography
          variant="h5"
          color={colors.text.primary}
          sx={{ mb: "1rem" }}
        >
          Plans
        </Typography>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            columnGap: "1rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "40%",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            <Typography
              sx={{ fontSize: 16, color: colors.text.primary, fontWeight: 600 }}
            >
              Add Plan
            </Typography>
            <Box
              sx={{
                display: "flex",
                width: "90%",
                flexDirection: "column",
                rowGap: "0.5rem",
              }}
            >
              <LabelTypography>Enter Plan Name</LabelTypography>
              <TextFieldBox
                placeholder=""
                name="planname"
                value={formData.planname}
                onChange={handleChange}
                error={!!errors.planname}
                helperText={errors.planname}
              />

              <LabelTypography>Enter Duration</LabelTypography>
              <TextFieldBox
                placeholder=""
                name="duration"
                type="number"
                value={formData.duration}
                onChange={handleChange}
                error={!!errors.duration}
                helperText={errors.duration}
              />
              <LabelTypography>Enter Price</LabelTypography>
              <TextFieldContainer>
                <Box
                  sx={{ display: "flex", width: "100%", alignItems: "center" }}
                >
                  <RupeeContainer>
                    <Typography>₹</Typography>
                  </RupeeContainer>
                  <TextFieldBox
                    placeholder=""
                    name="price"
                    type="number"
                    value={formData.price}
                    onChange={handleChange}
                  />
                </Box>
                {errors.price && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ marginTop: "0.5rem", ml: "3.5rem" }}
                  >
                    {errors.price}
                  </Typography>
                )}
              </TextFieldContainer>
              <LabelTypography>Discount</LabelTypography>
              <TextFieldContainer>
                <Box
                  sx={{ display: "flex", width: "100%", alignItems: "center" }}
                >
                  <RupeeContainer>
                    <Typography>%</Typography>
                  </RupeeContainer>
                  <TextFieldBox
                    placeholder=""
                    name="price"
                    type="number"
                    value={formData.discount}
                    onChange={handleChange}
                  />
                </Box>
           
              </TextFieldContainer>

              <Box display={"flex"} columnGap={"1rem"} width={"50%"}>
                <CustomButton
                  title={edit ? "Update Plan" : "Add Plan"}
                  variant="contained"
                  loading={loader}
                  fullWidth
                  handleClick={handleSubmit}
                  sx={{
                    backgroundColor: "#FFC200",
                    color: "white",
                    textTransform: "capitalize",
                    borderRadius: "8px",
                    marginTop: "1rem",
                  }}
                />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              width: "60%",
              flexDirection: "column",
              rowGap: "1rem",
            }}
          >
            {isLoading ? (
              <Loader />
            ) : (
              <PlanTable
                planData={planData}
                setFormData={setFormData}
                setEdit={setEdit}
                handleDelete={handleDelete}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}

export default PlanDetailsPopup;

const FileUploadBox = styled(Box)(({ theme }) => ({
  border: "2px dashed #76A2FF",
  borderRadius: 8,
  backgroundColor: "#EFFAFF",
  padding: "0.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
  transition: "border-color 0.3s",
  "&:hover": {
    borderColor: "2px dashed #76A2FF",
  },
}));

const HiddenFileInput = styled("input")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  opacity: 0,
  cursor: "pointer",
});
const LabelTypography = styled(Typography)(({ theme }) => ({
  color: colors.text.primary,
  fontSize: "14px",
}));
const TextFieldContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
}));
const RupeeContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "0.5rem 1rem",
  backgroundColor: "#FFF9E6",
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
}));
